<mat-card class="cost-smr-cont">
    <mat-card-content class="p-0">
        <app-library-item-header (unpinLibrary)="unpinLibrary()" (closeLibrary)="closeLibrary()" [title]="'COST_SUMMARY' | translate"></app-library-item-header>
        <div class="cost-smr-body">
            <p>Cost Summary content goes here.</p>
        </div>
    </mat-card-content>
</mat-card>